<!-- regular layout -->
<div *ngIf="!displaysSimplifiedLayout" class="rs-panel-big rs-bg-c2">
  <my-bill-odb-cover-details-divisions
    [divisions]="displayedCoverDetail.divisions"
    [testIDPrefix]="testIDPrefix"
    (categoryClick)="onCategoryClick($event)"
  ></my-bill-odb-cover-details-divisions>

  <my-bill-show-more-button
    *ngIf="hasZeroAmountInPackMobileDivisions"
    hideLabelKey="bills.cover.hideAllIncludedMobileNumbersButtonLabel"
    showLabelKey="bills.cover.showAllIncludedMobileNumbersButtonLabel"
    buttonZone="mybill.detail"
  >
    <my-bill-odb-cover-details-divisions
      [divisions]="zeroUsageDivisions"
      [firstIdentifierHasClassRsTit4]="false"
      [testIDPrefix]="testIDPrefix + '_zeroUsageDivision_'"
      (categoryClick)="onCategoryClick($event)"
    ></my-bill-odb-cover-details-divisions>
  </my-bill-show-more-button>
  <div
    my-bill-odb-sub-total
    [showVatText]="true"
    [amount]="displayedCoverDetail.totalAmount"
    [attr.data-cy]="testIDPrefix + '_total'"
  ></div>
</div>

<!-- simplified layout -->
<div
  class="panel rs-panel-clickable jsrs-clickable rs-clickable rs-padding-left4-m rs-padding-right4-m"
  *ngIf="displaysSimplifiedLayout"
  (click)="
    detailsClick.emit({
      division: displayedCoverDetail.divisions[0],
      amount:
        displayedCoverDetail.divisions[0].amount ??
        displayedCoverDetail.totalAmount
    })
  "
  data-tms-event="link-click"
  data-tms-link-zone="mybill.detail"
  [attr.data-tms-link-name]="
    getItemTitle(
      displayedCoverDetail.divisions[0].identifier,
      undefined,
      displayedCoverDetail.divisions[0].type
    )
  "
  [attr.data-cy]="
    'myBillCoverSingleDivision:' +
    getItemTitle(
      displayedCoverDetail.divisions[0].identifier,
      undefined,
      displayedCoverDetail.divisions[0].type
    )
  "
>
  <div class="rs-flex-row rs-flex-middle">
    <div class="rs-flex-column">
      <div class="rs-flex-row rs-flex-middle">
        <div class="rs-flex-column">
          <p class="rs-tit6">
            {{
              getItemTitle(
                displayedCoverDetail.divisions[0].identifier,
                undefined,
                displayedCoverDetail.divisions[0].type
              )
            }}
          </p>
        </div>
        <div class="rs-flex-column rs-flex-shrink">
          <p class="text-right">
            <strong
              ><px-currency-amount
                [amount]="
                  displayedCoverDetail.divisions[0].amount ??
                  displayedCoverDetail.totalAmount
                "
              ></px-currency-amount
              ><br /><span
                class="rs-txt-details rs-txt-s3"
                *ngIf="isVatInclusiveTextVisible"
                >{{ 'bills.cover.vatInclusive' | translate }}</span
              >
            </strong>
          </p>
        </div>
      </div>
    </div>
    <div class="rs-flex-column rs-flex-shrink">
      <span class="rs-panel-clickable-arrow" aria-hidden="true"></span>
    </div>
  </div>
</div>
